<template>
  <section class="section-careersForm">
    <div class="container">
      <div class="section-space-50"></div>
      <div class="section-header-title">Careers</div>
      <div class="section-space-25"></div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
          <div class="mb-5">
            <p>
              <span class="font-weight-600">Job Role:</span>
              <span>{{ job.job_role }}</span>
            </p>

            <p>
              <span class="font-weight-600">Required experience:</span>
              <span>{{ job.experience }} year(s)</span>
            </p>

            <p>
              <span class="font-weight-600">Location:</span>
              <span>{{ job.city_name }}</span>
            </p>

            <p class="mb-1">
              <span class="font-weight-600">Job Description:</span>
              <span>{{ job.job_description }}</span>
            </p>

            <ol class="pl-4">
              <!-- <li> -->
              <!--  v-for="(requirements, requirementsKey) in 5"
                :key="requirementsKey" -->
              <!-- </li> -->
            </ol>
          </div>
          <form @submit.prevent="onJobApplicationSubmit">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 mb-4">
                <label for="name" class="small mb-1">Full Name</label>
                <input
                  v-model="form.fullName"
                  type="text"
                  id="name"
                  class="form-control"
                  required
                  placeholder="Name"
                />
              </div>

              <div class="col-12 col-sm-6 col-md-6 mb-4">
                <label for="contactNumber" class="small mb-1"
                  >Phone Number</label
                >
                <input
                  v-model="form.phone"
                  ref="phoneNumber"
                  type="number"
                  id="contactNumber"
                  class="form-control"
                  required
                  maxlength="10"
                  onkeyup="this.value=this.value.replace(/[^0-9]+/g,'');"
                  onkeypress="if(this.value.length==10) return false;"
                  placeholder="Mobile Number"
                />
                <p class="text-danger" v-if="errorMessage">{{errorMessage}}</p>
              </div>

              <div class="col-12 col-sm-6 col-md-6 mb-4">
                <label for="email" class="small mb-1">Email address</label>
                <input
                  v-model="form.email"
                  type="email"
                  id="email"
                  placeholder="Email Address"
                  class="form-control"
                  required
                  ref="emailAddress"
                />
                <p class="text-danger" v-if="errorEmail">{{errorEmail}}</p>
              </div>

              <div class="col-12 col-sm-6 col-md-6 mb-4">
                <label for="location" class="small mb-1">Location</label>
                <input
                  v-model="form.location"
                  type="text"
                  id="location"
                  class="form-control"
                  placeholder="Location"
                  required
                  ref="location"
                />
                <p class="text-danger" v-if="errorLocation">{{errorLocation}}</p>
              </div>

              <div class="col-12 mb-5">
                <label for="attachResume" class="small mb-1 d-block"
                  >Attach Resume</label
                >
                <input
                  name="resume"
                  id="resume_id"
                  @change="fileUpload"
                  type="file"
                  class="d-none"
                  accept="application/pdf, application/msword, .doc"
                />

                <div class="d-flex align-items-center">
                  <label
                    for="resume_id"
                    class="btn btn-sm btn-primary mb-0 mr-3"
                    >Choose file</label
                  >
                  <div>
                    <span class="lh-1 d-table">{{
                      form.resume_file_name
                        ? form.resume_file_name
                        : "No file chosen"
                    }}</span>
                    <small class="text-muted d-block lh-1"
                      >(only .doc & .pdf allowed)</small
                    >
                  </div>
                </div>
                <p class="text-danger" v-if="fileError">{{ fileError }}</p>
              </div>

              <div class="col-12 text-center">
                <input
                  type="submit"
                  class="btn btn-primary px-5"
                  value="SUBMIT APPLICATION"
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="section-space-100"></div>
    </div>

    <b-modal
      hide-footer
      ref="applicationSubmittedModal"
      id="formSumbittedConfirmation"
      title="Application submitted"
    >
      <div>
        <div class="text-center w-75 mx-auto py-5">
          <div>
            <svg
              width="57"
              fill="none"
              height="57"
              viewBox="0 0 57 57"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.9821 18.5579L25.0852 32.4486L17.9878 25.2743C17.0518 24.3584 15.5699 24.3584 14.712 25.198C13.7761 26.1139 13.7761 27.564 14.634 28.4035L23.3694 37.1806C23.8373 37.6386 24.4613 37.8675 25.0072 37.8675C25.5532 37.8675 26.1771 37.6386 26.6451 37.2569L43.2578 21.8398C44.1938 21.0003 44.2718 19.5501 43.3358 18.6343C42.3999 17.7184 40.918 17.7184 39.9821 18.5579Z"
                fill="#00A651"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 28.4003C0 12.7417 12.7865 0 28.5 0C44.2135 0 57 12.7417 57 28.4003C57 44.0588 44.2135 56.8006 28.5 56.8006C12.7865 56.8006 0 44.0588 0 28.4003ZM4.62164 28.4002C4.62164 41.5257 15.3284 52.1951 28.5 52.1951C41.6716 52.1951 52.3784 41.5257 52.3784 28.4002C52.3784 15.2747 41.6716 4.60535 28.5 4.60535C15.3284 4.60535 4.62164 15.2747 4.62164 28.4002Z"
                fill="#00A651"
              />
            </svg>
          </div>

          <p class="my-4">
            Your job application has submitted successfully.
          </p>

          <button class="btn btn-primary w-100" v-on:click="closeModal()">
            DONE
          </button>
          <!-- $['applicationSubmittedModal'].hide() -->
        </div>
        <div class="rainbow-line">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import JobService from "@/apiServices/JobService";
import ExtrasService from "@/apiServices/ExtrasService";

export default {
  data() {
    return {
      job: null,
      errorMessage: null,
      errorEmail: null,
      errorLocation: null,
      fileError: null,
      form: {
        fullName: "",
        phone: "",
        email: "",
        location: "",
        resume: null,
        resume_file_name: "",
      },
    };
  },
  methods: {
    fileUpload(e) {
      const file = e.target.files[0];
      // console.log("FILE",file);
      if (!["application/pdf", "application/msword", ".doc"].includes(file.type)) {
        this.fileError = "Please upload only pdf or doc file";
        return false;
      }else{
        this.fileError = null;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.resume_file_name = file.name;
        this.form.resume = reader.result;
      };
      reader.onerror = (error) => {
        console.log("Error in file read ", error);
        // alert("Cannot read file");
        this.fileError = "Cannot read file";
      };
    },

    async onJobApplicationSubmit() {
      this.errorMessage = null;
      this.errorEmail = null;
      this.errorLocation = null;
      this.fileError = null;
      if(String(this.form.phone).length !== 10 || /(\d)\1{9}/.test(this.form.phone)){
        this.errorMessage = "Enter Valid Mobile No.";
        this.$nextTick(() => {
          this.$refs.phoneNumber.focus();
        });
        return false;
      }
      if (!this.form.email || !/\S+@\S+\.\S+/.test(this.form.email)) {
        this.errorEmail = "Enter Valid Email Address";
        this.$nextTick(() => {
          this.$refs.emailAddress.focus();
        });
        return false;
      }
      if (!this.form.location || /[\d]+/.test(this.form.location)) {
        this.errorLocation = "Enter Valid Location";
        this.$nextTick(() => {
          this.$refs.location.focus();
        });
        return false;
      }
      if(this.form.resume_file_name === ""){
        this.fileError = "Please Upload Resume";
        return false;
      }
      await ExtrasService.jobApplication(this.form)
        .then((response) => {
          console.log(response);
          this.form = {
            fullName: "",
            phone: "",
            email: "",
            location: "",
            resume: null,
            resume_file_name: "",
          };
          this.$refs["applicationSubmittedModal"].show();
        })
        .catch((err) => {
          console.log("Error in job application ", err);
        });
    },

    async getJob(job_id) {
      const { data } = await JobService.GetJob({ job_id });
      if (data && data.status) {
        this.job = data.data;
      }
    },
    closeModal() {
      this.$refs["applicationSubmittedModal"].hide();
    },
  },
  async beforeMount() {
    const { job_id } = this.$route.params;
    if (job_id) {
      await this.getJob(job_id);
    } else {
      this.$router.go(-1);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/careers.vue